export default "__VITE_ASSET__Crk8gscq__"